import type { FilterOptions } from "@/utils/liveData";

interface FilterBarProps {
  value: FilterOptions;
  onChange: (next: FilterOptions) => void;
  showSort?: boolean;
}

const regionOptions = [
  { value: "all", label: "全部地区" },
  { value: "domestic", label: "国内" },
  { value: "international", label: "国际" },
];

const statusOptions = [
  { value: "all", label: "全部状态" },
  { value: "live", label: "直播中" },
  { value: "ended", label: "已结束" },
];

const levelOptions = [
  { value: "all", label: "全部等级" },
  { value: "normal", label: "普通主播" },
  { value: "vip", label: "VIP 主播" },
];

const sortOptions = [
  { value: "hot", label: "综合热度" },
  { value: "viewers", label: "观看人数" },
  { value: "time", label: "开播时间" },
];

function FilterGroup({
  label,
  options,
  active,
  onSelect,
}: {
  label: string;
  options: { value: string; label: string }[];
  active: string;
  onSelect: (value: string) => void;
}) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-xs font-medium text-foreground-500">{label}</span>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            onClick={() => onSelect(option.value)}
            className={`whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium transition-colors ${
              active === option.value
                ? "bg-primary-500 text-background-50"
                : "bg-secondary-100 text-foreground-700 hover:bg-secondary-200"
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterBar({ value, onChange, showSort = true }: FilterBarProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4">
      <div className="flex flex-col gap-4">
        <FilterGroup
          label="地区"
          options={regionOptions}
          active={value.region ?? "all"}
          onSelect={(region) => onChange({ ...value, region })}
        />
        <div className="h-px w-full bg-background-200" />
        <FilterGroup
          label="直播状态"
          options={statusOptions}
          active={value.status ?? "all"}
          onSelect={(status) => onChange({ ...value, status })}
        />
        <div className="h-px w-full bg-background-200" />
        <FilterGroup
          label="主播等级"
          options={levelOptions}
          active={value.level ?? "all"}
          onSelect={(level) => onChange({ ...value, level })}
        />
        {showSort && (
          <>
            <div className="h-px w-full bg-background-200" />
            <FilterGroup
              label="排序"
              options={sortOptions}
              active={value.sort ?? "hot"}
              onSelect={(sort) => onChange({ ...value, sort })}
            />
          </>
        )}
      </div>
    </div>
  );
}